import { PlusOutlined } from "@ant-design/icons";
import { Button, Card, Typography } from "antd";

const { Title } = Typography;



export function ProjectListHeader({
  onAddProject,
  canAddProject,
}) {
  return (
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          
          flexWrap: "wrap",
        }}
      >
        <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={onAddProject}
          disabled={!canAddProject}
          style={{ borderRadius: "4px",backgroundColor:"#0958d9", fontWeight: 450 ,height:40}}
        >
          Add Project
        </Button>
      </div>
  );
}
